import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled
} from '@mui/material';

const BootstrapSelect = styled(Select)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:focus': {
      borderRadius: 4,
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function BootstrapSelectField({
  id,
  label,
  value,
  onChange,
  options = [],
  disabled = false,
  required = false,
  fullWidth = true,
  placeholder,
  error = false,
  helperText,
  ...otherProps
}) {
  const inputId = id || `${label?.toLowerCase().replace(/\s+/g, '-')}-select`;

  return (
    <FormControl variant="standard" fullWidth={fullWidth} error={error}>
      {label && (
        <InputLabel
          shrink
          htmlFor={inputId}
          sx={{
            fontSize: '1.2rem',
            fontWeight: 500,
            color: error ? 'error.main' : 'inherit'
          }}
        >
          {label}
        </InputLabel>
      )}
      <BootstrapSelect
        id={inputId}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        displayEmpty
        {...otherProps}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={typeof option === 'string' ? option : option.value}
            value={typeof option === 'string' ? option : option.value}
          >
            {typeof option === 'string' ? option : option.label}
          </MenuItem>
        ))}
      </BootstrapSelect>
      {helperText && (
        <div style={{
          fontSize: '0.75rem',
          color: error ? 'red' : '#666',
          marginTop: '4px',
          marginLeft: '14px'
        }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
}
